module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Price1-5fb6794f5f9ee4b5664a2c8e56806795.svg";